import { render, staticRenderFns } from "./ItemMapList.vue?vue&type=template&id=71d1f058&scoped=true"
import script from "./ItemMapList.vue?vue&type=script&lang=js"
export * from "./ItemMapList.vue?vue&type=script&lang=js"
import style0 from "./ItemMapList.vue?vue&type=style&index=0&id=71d1f058&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d1f058",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71d1f058')) {
      api.createRecord('71d1f058', component.options)
    } else {
      api.reload('71d1f058', component.options)
    }
    module.hot.accept("./ItemMapList.vue?vue&type=template&id=71d1f058&scoped=true", function () {
      api.rerender('71d1f058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/order-receive/itemmap/ItemMapList.vue"
export default component.exports